export default "__VITE_ASSET__DiorGohR__"